const isTouchDevice = () => {
  return (
    typeof window !== 'undefined'
    && (('ontouchstart' in window)
      || (navigator.maxTouchPoints > 0))
  );
};

export default isTouchDevice;